module.exports = __webpack_public_path__ + "img/EGS_icon_02.d616075d.svg";